import { ANNOTATIONS_SETTINGS_SHOW } from 'components/ChartTools';

import { CHANGE_LOCATION } from '@gogame/screens';

import { periodSchema } from '../schemas';
import {
  seriesReducer,
  ADD_SERIES,
  DELETE_SERIES,
  SET_SERIES,
} from './seriesReducer';

export const CLEAR = 'CLEAR';
export const SET_PERIOD = 'SET_PERIOD';
export const HIDE_SERIES = 'HIDE_SERIES';
export const SHOW_SERIES = 'SHOW_SERIES';
export const SET_CHART_SETTINGS = 'SET_CHART_SETTINGS';
export const HIDE_CHART_ANNOTATIONS = 'HIDE_CHART_ANNOTATIONS';
export const SHOW_CHART_ANNOTATIONS = 'SHOW_CHART_ANNOTATIONS';
export const SET_CHART_VIEW_SETTINGS = 'SET_CHART_VIEW_SETTINGS';
export const COLLAPSE_COLUMNS = 'COLLAPSE_COLUMNS';
export const REORDER_COLUMNS = 'REORDER_COLUMNS';

export function kpiReducer(state = {}, action) {
  switch (action.type) {
    case CHANGE_LOCATION: {
      return action.payload;
    }
    case REORDER_COLUMNS:
      return { ...state, columns: { ...state.columns, order: action.payload } };
    case COLLAPSE_COLUMNS:
      return {
        ...state,
        columns: { ...state.columns, collapsed: action.payload },
      };
    case SET_PERIOD: {
      return {
        ...state,
        period: action.payload,
      };
    }

    case CLEAR: {
      return {
        ...state,
        period: periodSchema.default(),
      };
    }

    case SET_CHART_SETTINGS:
      return { ...state, chartSettings: action.payload };

    case SET_CHART_VIEW_SETTINGS:
      return { ...state, chartViewSettings: action.payload };

    case DELETE_SERIES:
    case SET_SERIES:
    case ADD_SERIES: {
      return {
        ...state,
        series: seriesReducer(state.series, action),
      };
    }
    case HIDE_SERIES:
      return {
        ...state,
        hidden: [...state.hidden, ...action.payload],
      };

    case SHOW_CHART_ANNOTATIONS:
      return {
        ...state,
        annotations: {
          ...action.payload,
          [ANNOTATIONS_SETTINGS_SHOW]: true,
        },
      };

    case HIDE_CHART_ANNOTATIONS:
      return {
        ...state,
        annotations: {
          ...state.annotations,
          [ANNOTATIONS_SETTINGS_SHOW]: false,
        },
      };

    case SHOW_SERIES:
      return {
        ...state,
        hidden: state.hidden.filter((id) => !action.payload.includes(id)),
      };

    default:
      return state;
  }
}
